import { atom } from 'jotai';

import { Steps } from '../types';

export const stepState = atom<Steps>(Steps.UPLOAD);
